<template>
  <div class="report-collapse-expand">
    <a
      v-tooltip="disabled"
      role="button"
      class="btn btn-naked collapse-expand-link"
      :disabled="disabled"
      data-placement="bottom"
      @click.prevent="toggle()"
    >
      <i
        class="hi hi-16"
        :class="icon_class"
      />
      {{ label }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportCollapseAllRowsToggle',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.collapseAllRows ? 'Expand' : 'Collapse';
    },
    icon_class() {
      return this.collapseAllRows ? 'hi-expand' : 'hi-collapse';
    },
    ...mapGetters(['collapseAllRows']),
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$store.dispatch('toggleCollapseAllRows');
      }
    },
  },
};
</script>
